module.exports = __webpack_public_path__ + "static/media/facehawk.59792143.png";